import basic from './basic'

export default {
  basic,
}